
//******************Exchange Rate Server Calls******************;

import {UserRoleListActions} from './UserRoleListConstants';
import store from '../../../../Store/store'
import {ROOT_URL,getCookie} from '../../../../Config/Config';
import {failure_messages} from "Messages"


export const UserRoleListServer = {
  //  getUserRoleList:getUserRoleList,
  getUserRoleList:getUserRoleList,
  //  updateUserRoleList:updateUserRoleList
};

//******************Insert UserRoleLists******************;

function getUserRoleList(){
      const request=fetch(ROOT_URL+'/api/applicationUser/getUserRoleListAdminEnd', {
          method: 'Post',
          mode: 'cors',
          headers: { 
            'authorization':getCookie("admin_token"),
            'Accept': 'application/json',
            'Content-Type': 'application/json'  
          },
          }).then((response)=>{
           response.json().then(response=>{
             if(response.status == "200"){
            //  alert(JSON.stringify(response.weekUserRoles))
             
            store.dispatch({type:UserRoleListActions.UserRoleList_GET.SUCCESS,payload:response.data});
            return ;
            }else
            {
              store.dispatch({type:UserRoleListActions.UserRoleList_GET.FAILED, error:response.error});
              return ;
              }    
           });
          }).catch((error) => {
          //  alert(error)
           store.dispatch({type:UserRoleListActions.UserRoleList_GET.FAILED, error:failure_messages.unExpectedError});
            })
      return {type:UserRoleListActions.UserRoleList_GET.LOADING}

};
  
//******************Get UserRoleLists******************;


//******************Update UserRoleList******************;

  
// function getUserRoleList(){
//       const request=fetch(ROOT_URL+'/api/exchangeRate/getExchangeRate/', {
//           method: 'GET',
//           mode: 'cors',
//           headers: {'Content-Type':'application/json'},
//          // body: JSON.stringify(data)
//           }).then((response)=>{
//             response.json().then(response=>{
//               if(response.status == "200"){
//                 console.log(response)
//                 if(response.UserRoleList.length>0)
//              store.dispatch({type:UserRoleListActions.UserRoleList_Get.SUCCESS,payload:response.UserRoleList});
//              else
//              store.dispatch({type:UserRoleListActions.UserRoleList_GET.NEW});
             
//              return ;
//              }else
//              {
//                store.dispatch({type:UserRoleListActions.UserRoleList_Get.FAILED});
//                return ;
//                }    
//             });
//            }).catch((error) => {
//             store.dispatch({type:UserRoleListActions.UserRoleList_Get.FAILED});
//           })
//        return {type:UserRoleListActions.UserRoleList_GET.LOADING}
 
//     };
  
// function updateUserRoleList(data){
//   const request=fetch(ROOT_URL+'/api/exchangeRate/BulkUpdateExchangeRate', {
//     method: 'Post',
//     mode: 'cors',
//     headers: {'Content-Type':'application/json'},
//     body: JSON.stringify(data)
//     }).then((response)=>{
//      response.json().then(response=>{
//        if(response.status == "200"){
//          console.log(response)
//       store.dispatch({type:UserRoleListActions.UserRoleList_GET.SUCCESS});
//       return ;
//       }else
//       {
//         store.dispatch({type:UserRoleListActions.UserRoleList_GET.FAILED});
//         return ;
//         }    
//      });
//     }).catch((error) => {
//       store.dispatch({type:UserRoleListActions.UserRoleList_GET.FAILED});
//     })
// return {type:UserRoleListActions.UserRoleList_GET.LOADING}

// };
